import requestAction from '../../utils/requestAction'
import { pushAlert } from '../alert'
import { LocalStorage } from '../../localStorage'

export const sendPasswordRecovery = (params: string, email: string, textAlert: string) => {
  return requestAction('PASSWORD_RECOVERY', params)('auth/password-recovery', 'POST', { email, lang: LocalStorage.getSelectedLocale() }, undefined, undefined,
    (dispatch) => dispatch(pushAlert(textAlert)))
}